import { StringMask } from '@/utils/StringMask';
import { NInput } from 'naive-ui';
import { defineComponent, ref, watch } from 'vue';

const MAX_INPUT_LENGTH = 11;

export const AppInputCpf = defineComponent({
	name: 'AppInputCpf',
	extends: NInput,

	props: {
		modelValue: String,
		readonly: Boolean,
	},
	emits: ['update:modelValue', 'update:value', 'change'],

	setup(props, { emit }) {
		const mask = '000.000.000-00';
		const fieldMask = new StringMask({ mask: mask });
		const maskedValue = ref(
			props.modelValue?.toString() ? fieldMask.apply(props.modelValue.toString()).maskedValue : '',
		);
		const isReadonly = props.readonly;

		watch(
			() => props.modelValue,
			(v) => {
				if (!v) {
					maskedValue.value = '';
					return;
				}

				const digits = v.toString().replace(/\D/g, '');
				maskedValue.value = fieldMask.apply(digits).maskedValue;
			},
			{ immediate: true },
		);

		function handleInput(value: string) {
			value = value.toString();
			const response = fieldMask.apply(value);
			const result = response.maskedValue;
			maskedValue.value = result;

			if (response.unmaskedValue.length != 0) {
				emit('update:modelValue', result);
				emit('update:value', result);
			}
		}

		function onChange() {
			emit('change', maskedValue.value);
		}

		return () => (
			<NInput
				placeholder={mask}
				inputProps={{
					autofocus: true,
					maxlength: MAX_INPUT_LENGTH,
					autocomplete: 'cpf',
					inputmode: 'numeric',
				}}
				onChange={onChange}
				onInput={handleInput}
				value={maskedValue.value}
				disabled={isReadonly}
			/>
		);
	},
});

export default AppInputCpf;
